import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import Paragraph from "atoms/typography/paragraph";
import React from "react";
import { t } from "utilities/localization-utils";

export interface AddPageButtonProps {
    onCreatePageClick: () => void;
    viewSetting: "-list" | "-grid";
}

const CSS_CLASS_NAME = "c-add-page-button";

const AddPageButton: React.FC<AddPageButtonProps> = ({
    onCreatePageClick,
    viewSetting = "-grid",
}) => {
    return (
        <div
            className={`${CSS_CLASS_NAME} ${viewSetting}`}
            onClick={onCreatePageClick}>
            <div className={`${CSS_CLASS_NAME}__circle`}>
                <Icon type={Icons.Plus} size={IconSizes.Large} />
            </div>
            <div className={`${CSS_CLASS_NAME}__text`}>
                <Paragraph>{t("notebooks-create-new-page")}</Paragraph>
            </div>
        </div>
    );
};

export default AddPageButton;
